import "./landing-page-info-message.component.scss";

export default {
    template: require('./landing-page-info-message.component.html'),
    transclude: true,
    controller: function () {
        'ngInject';
    }
};
